import React from 'react';
import { CTAButton } from './CTAButton';
import { HERO_IMAGE, OFFER_ANCHOR } from '../data/electrical';
export function FinalCTA() {
  return <section className="bg-carbon px-4 py-4 sm:py-6" data-id="element-51" data-mp="3ue89lkm0j4sy">
      <div className="mx-auto max-w-3xl" data-id="element-52" data-mp="c7aggcphakk8">
        <h2 className="text-center text-lg leading-tight text-white sm:text-3xl" data-id="element-53" data-mp="c83nzfw9he3f">
          ONE LAST QUESTION
        </h2>
        <p className="mt-1.5 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-54" data-mp="87jqucbouaha">
          How many times have you known what the electrical symptom was...
        </p>
        <p className="mt-1 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-55" data-mp="h3rdjweno99g">
          but still had to spend time searching through different resources to
          decide what to test next?
        </p>
        <p className="mt-1 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-56" data-mp="14vfyust27xgw">
          You can keep jumping between scattered diagrams, manuals and
          references.
        </p>
        <p className="mt-1 text-[13px] font-bold leading-snug text-white sm:text-base" data-id="element-57" data-mp="2c4o9ar3rqx3k">
          Or you can open one organized visual diagnostic system.
        </p>
        <p className="mt-1.5 text-center font-display text-base uppercase leading-tight text-volt sm:text-2xl" data-id="element-58" data-mp="2h49iducnklu0">
          Find the symptom. Trace the circuit. Test it. Verify it.
        </p>

        <a href={OFFER_ANCHOR} className="mt-2 block" data-id="element-59" data-mp="2r3ibkkzp1wfb">
          <img src={HERO_IMAGE} alt="ELECTRICAL DIAGNOSTIC PRO™ complete system" loading="lazy" className="mx-auto w-full max-w-md" data-id="element-60" data-mp="2v3sdnmkd82ow" />
        </a>

        <p className="mt-1.5 text-center font-display text-xl uppercase text-white sm:text-2xl" data-id="element-61" data-mp="34sshpkdq5o9y">
          ⚡ ELECTRICAL DIAGNOSTIC PRO™
        </p>
        <p className="mt-0.5 text-center font-head text-[11px] font-bold uppercase tracking-wide text-white/80 sm:text-sm" data-id="element-62" data-mp="39rna9e1hur79">
          THE COMPLETE VISUAL TROUBLESHOOTING SYSTEM FOR ELECTRICAL
          PROFESSIONALS
        </p>
        <p className="mt-0.5 text-center text-[11px] font-semibold text-white/70 sm:text-sm" data-id="element-63" data-mp="1jocy0dxsczwj">
          Diagnostics • Measurements • Circuits • Protection • Controls • Real
          Cases
        </p>

        <p className="mt-1.5 text-center font-display text-base uppercase text-volt sm:text-xl" data-id="element-64" data-mp="1sgn87v8ol5ds">
          🔥 GET THE COMPLETE SYSTEM TODAY
        </p>
        <CTAButton className="mx-auto mt-1 max-w-md" sub="Immediate Access • Digital Delivery" subTone="light" data-id="element-65" data-mp="1np5adg1yfkx1">
          ⚡ YES! I WANT ELECTRICAL DIAGNOSTIC PRO™
        </CTAButton>
        <p className="mt-1 text-center text-[11px] font-bold text-white/80 sm:text-xs" data-id="element-66" data-mp="1xfhytjcw3y8g">
          🛡️ 7-Day Money-Back Guarantee{' '}
          <span className="text-volt" data-id="element-67" data-mp="27e7auvi3uogs">⚡ COMPLETE 6-IN-1 SYSTEM</span>
        </p>
      </div>
    </section>;
}